import { isRouteErrorResponse, useRouteError } from "react-router-dom"

export function useErrorBoundaryMessage() {
  const error = useRouteError()

  const isNoRouteMatch =
    (isRouteErrorResponse(error) && error.status === 404) ||
    (error instanceof Error && /no route found for path/i.test(error.message))

  function getErrorMessage(): string {
    if (isNoRouteMatch) {
      return "The page you're looking for doesn't exist or has moved."
    }
    if (isRouteErrorResponse(error)) {
      return error.statusText || "An error occurred with the request."
    } else if (error instanceof Error) {
      return error.message
    } else if (typeof error === "string") {
      return error
    } else {
      return "An unknown error occurred."
    }
  }

  function getErrorStatus(): number | undefined {
    if (isRouteErrorResponse(error)) {
      return error.status
    }
    if (isNoRouteMatch) {
      return 404
    }
    return undefined
  }

  function retry() {
    window.location.reload()
  }

  return {
    errorMessage: getErrorMessage(),
    errorStatus: getErrorStatus(),
    retry,
  }
}
